import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { InternalFlexBox } from "../../flexBox/internal/InternalFlexBox.js";
const InternalCluster = /*#__PURE__*/ forwardRef(({ children, justifyContent = 'flex-start', alignItems = 'center', gap = '300', ...flexBoxProps }, ref)=>/*#__PURE__*/ jsx(InternalFlexBox, {
        ...flexBoxProps,
        gap: gap,
        justifyContent: justifyContent,
        alignItems: alignItems,
        flexWrap: "wrap",
        ref: ref,
        children: children
    }));
InternalCluster.displayName = 'InternalCluster';
export { InternalCluster };
